/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsMeasurementQualityData
 */
export interface GoogleAnalyticsMeasurementQualityData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    propertyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    currencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    completeness?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    coversRequestedRange?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    sessions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    transactions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    purchaseRevenue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsMeasurementQualityData
     */
    fetchedAt?: string;
}

/**
 * Check if a given object implements the GoogleAnalyticsMeasurementQualityData interface.
 */
export function instanceOfGoogleAnalyticsMeasurementQualityData(value: object): value is GoogleAnalyticsMeasurementQualityData {
    return true;
}

export function GoogleAnalyticsMeasurementQualityDataFromJSON(json: any): GoogleAnalyticsMeasurementQualityData {
    return GoogleAnalyticsMeasurementQualityDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsMeasurementQualityDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsMeasurementQualityData {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'completeness': json['completeness'] == null ? undefined : json['completeness'],
        'coversRequestedRange': json['coversRequestedRange'] == null ? undefined : json['coversRequestedRange'],
        'sessions': json['sessions'] === undefined ? undefined : json['sessions'] === null ? null : json['sessions'],
        'transactions': json['transactions'] === undefined ? undefined : json['transactions'] === null ? null : json['transactions'],
        'purchaseRevenue': json['purchaseRevenue'] === undefined ? undefined : json['purchaseRevenue'] === null ? null : json['purchaseRevenue'],
        'fetchedAt': json['fetchedAt'] == null ? undefined : json['fetchedAt'],
    };
}

export function GoogleAnalyticsMeasurementQualityDataToJSON(json: any): GoogleAnalyticsMeasurementQualityData {
    return GoogleAnalyticsMeasurementQualityDataToJSONTyped(json, false);
}

export function GoogleAnalyticsMeasurementQualityDataToJSONTyped(value?: GoogleAnalyticsMeasurementQualityData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'accountId': value['accountId'],
        'propertyId': value['propertyId'],
        'timeZone': value['timeZone'],
        'currencyCode': value['currencyCode'],
        'completeness': value['completeness'],
        'coversRequestedRange': value['coversRequestedRange'],
        'sessions': value['sessions'],
        'transactions': value['transactions'],
        'purchaseRevenue': value['purchaseRevenue'],
        'fetchedAt': value['fetchedAt'],
    };
}

